import {
  FACEBOOK_LOGIN_ERROR,
  GOOGLE_LOGIN_ERROR,
} from 'actiontypes/user';

// import getAirbrakeClient from 'shared/airbrake/getClient';
// import { stringifyError } from 'utils';

// const client = getAirbrakeClient();
// const notify = error => client.notify({ error: stringifyError(error) });

/**
 * Listen for errors and notify Airbrake when they happen.
 * @param {*} state
 * @param {*} action
 */
export default function reducer(state = {}, action) {
  const { type } = action;
  switch (type) {
    case FACEBOOK_LOGIN_ERROR:
    case GOOGLE_LOGIN_ERROR:
      // notify(error);
      return state;

    default:
      return state;
  }
}